import DateTimePicker from 'react-datetime-picker';

import styles from '../styles/BasicFormDateInput.module.css';

export default function BasicFormDateInput({
  label,
  updateKey,
  value,
  onChange,
  disabled = false,
  className,
  format = 'MM/dd/yyyy'
}) {
  return (
    <div className={styles.inputContainer}>
      <label htmlFor={`${updateKey}-input`}>{label}</label>
      <DateTimePicker
        disabled={disabled}
        required={label[0] === '*'}
        name={`${updateKey}`}
        id={`${updateKey}-input`}
        value={value}
        selected={value}
        onChange={onChange}
        className={`${className} ${styles.input}`}
        format={format}
        showTimeInput
        timeIntervals={40}
        showTimeSelect
      />
    </div>
  );
}
